import { UploadData, useUploadStore } from '../../../../store/uploadStore';
import React from 'react';
import { stylesheet } from 'typestyle';
import { Gray100 } from '@traceair/tds';
import { calculateRemainingTimeSeconds, formatRemainingTime } from '../helpers/remainingTime';

const css = stylesheet({
  remainingTime: {
    marginTop: 8,
    color: Gray100,
  },
});

interface Props {
  currentUploads: UploadData[];
}

export const GlobalUploadRemainingTime = ({ currentUploads }: Props) => {
  const { bytesPerSecond, fileRegistrationTimeMs } = useUploadStore();

  const totalRemainingSeconds = currentUploads.reduce((acc, upload) => {
    return acc + (calculateRemainingTimeSeconds(bytesPerSecond, fileRegistrationTimeMs, upload) ?? 0);
  }, 0);
  const totalRemainingTime = formatRemainingTime(totalRemainingSeconds ? totalRemainingSeconds : null);

  return <div className={css.remainingTime}>{totalRemainingTime}</div>;
};
